import React, {useState} from "react"
import Loading from "./Loading"

const useLoading = props => {
	const [visible, setVisible] = useState(false)

	const showLoading = () => setVisible(true)
	const hideLoading = () => setVisible(false)
	
	const loading = visible ? <Loading /> : null
	
	return [loading, showLoading, hideLoading]
}


export default useLoading